import { fontStyle } from "@pages/casino/assets/styles/mixins";
import styled, { css } from "styled-components";

const commonFlexStyles = css`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	justify-content: flex-start;
	padding: 0 10px;
	margin-bottom: 20px;

	@media (min-width: 744px) {
		justify-content: flex-start;
		flex-direction: row-reverse;
	}
`;

export const IconContainer = styled.div`
	${commonFlexStyles}
	padding: 4px;
	gap: 10px;
	border-radius: 15px;
	background: var(--Gray-90, #120507);
	margin-right: 14px;
	cursor: pointer;

	@media (min-width: 744px) {
		margin-right: 0;
	}

	&:hover {
		opacity: 0.8;
	}
`;

export const TagContainer = styled.div`
	${commonFlexStyles}
	height: 24px;
	padding: 0px;
	gap: 6.251px;
	margin-right: 10px;

	svg {
		cursor: pointer;
		@media (min-width: 1600px) {
			width: 18px;
			height: 18px;
		}
	}
`;

export const Tag = styled.div`
	${fontStyle}
	text-transform: uppercase;
	color: var(--main-color);

	@media (min-width: 744px) {
		font-size: 11.251px;
		font-style: normal;
		font-weight: 600;
		line-height: 13.751px;
		letter-spacing: 0.313px;
	}

	@media (min-width: 1600px) {
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}
`;
